// extracted by mini-css-extract-plugin
export var primitiveLabel = "_v6-0";